/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { Map, List, fromJS } from 'immutable';

const moveLinkToFirstPlaceInStore = (state, id) => {
  const idx = state.findIndex(link => link == id);
  if (idx > -1) {
    if (idx === 0) {
      return state;
    }
    return state.delete(idx).insert(0, id);
  } return state.insert(0, id);
};

const moveLinkToLastPlaceInStore = (state, id) => {
  const idx = state.findIndex(link => link == id);
  if (idx > -1) {
    if (idx === state.size - 1) {
      return state;
    }
    return state.delete(idx).push(id);
  } return state.push(id);
};

const clearQuantityData = (state) => state.clear();

export const linksOrderReducer = (state = List(), action) => {
  switch (action.type) {
    case 'SET_LINK_FIRST':
      return moveLinkToFirstPlaceInStore(state, action.id);
    case 'SET_LINK_LAST':
      return moveLinkToLastPlaceInStore(state, action.id);
    case 'LINK_QUANTITY_CLEARED':
      return clearQuantityData(state);
    default:
      return state;
  }
};

const updateQuantity = (state, id, obj) =>
  state.set(id, (state.get(id) ? state.get(id) : Map()).merge(fromJS(obj)));

const clearQuantityStore = (state) => state.clear();

export const linksQuantityReducer = (state = Map(), action) => {
  switch (action.type) {
    case 'LINK_QUANTITY_CHANGED':
      return updateQuantity(state, action.quatityId, action.quantityObject);
    case 'LINK_QUANTITY_CLEARED':
    case 'STOP_LINKING':
    case 'START_LINKING_TO_IDX':
    case 'START_LINKING_TRANPOSRT_TO_IDX':
    case 'START_ASSIGNING_TRANSPORT_TO_LINK':
    case 'START_LINKING_EXISTING':
      return clearQuantityStore(state);
    default:
      return state;
  }
};

const setProductTypeFilter = (state, idx) =>
  state.set('productToLinkIdx', idx).delete('linkIdx')
    .set('linkToTransport', false)
    .delete('productId')
    .set('linkToExistingLink', false)
    .set('fromList', false);

const startLinkingTransport = (state, idx) =>
  state.set('productToLinkIdx', idx).delete('linkIdx')
    .set('linkToTransport', true)
    .delete('productId')
    .set('linkToExistingLink', false)
    .set('fromList', false);

const startAssigningTransport = (state, prodIdx, linkIdx, productId,
  fromList, multiNodalQuantity) =>
  state.set('productToLinkIdx', prodIdx).set('linkIdx', linkIdx).set('fromList', fromList)
    .set('productId', productId)
    .set('linkToTransport', true)
    .set('multiNodalQuantity', multiNodalQuantity)
    .set('linkToExistingLink', false);

const startAssigningDealToExistingLink = (state, prodIdx, linkIdx) =>
  state.set('productToLinkIdx', prodIdx).set('linkIdx', linkIdx)
    .set('linkToTransport', false)
    .delete('productId')
    .set('linkToExistingLink', true)
    .set('fromList', false);

const changeLinkSavePermission = (state, bool) =>
  state.set('allowLinkSave', bool);

const stopLinkCreation = (state) =>
  state.delete('productToLinkIdx').delete('linkToTransport').delete('linkIdx')
    .delete('linkToExistingLink')
    .delete('productId')
    .delete('multiNodalQuantity');

export const linksReducer = (state = Map(), action) => {
  switch (action.type) {
    case 'START_LINKING_TO_IDX':
      return setProductTypeFilter(state, action.idx);
    case 'START_LINKING_TRANPOSRT_TO_IDX':
      return startLinkingTransport(state, action.idx);
    case 'CHANGED_LINK_SAVING_PERMISSION':
      return changeLinkSavePermission(state, action.bool);
    case 'START_ASSIGNING_TRANSPORT_TO_LINK':
      return startAssigningTransport(state, action.prodIdx, action.linkIdx,
        action.productId, action.fromList, action.multiNodalQuantity);
    case 'START_LINKING_EXISTING':
      return startAssigningDealToExistingLink(state, action.prodIdx, action.linkIdx);
    case 'STOP_LINKING':
      return stopLinkCreation(state);
    case 'CLEAR_DEAL':
      return stopLinkCreation(state);
    case 'LINK_BL_QUANTITY_CHANGED':
      return state.setIn([action.id, 'billLandingQuantity'], action.blQuantity);
    case 'LINK_BL_DATE_CHANGED':
      return state.setIn([action.id, 'billLadingDate'], action.blDate);
    case 'LINK_No_TRANSPORT_BL_CHANGED':
      return state.setIn([action.id, 'noTransportBl'], action.value);
    case 'SELECTED_LINKS':
      return state.setIn(['links', 'selected'], action.links);
    default:
      return state;
  }
};

const setSelectedAtoms = (state, atoms) =>
  state.set('selected', atoms);

const removeDeletedDeals = (state, id) => {
  let stateNew = state;

  let selected = stateNew.get('selected');
  if (selected) {
    selected = selected.delete(Number(id));
    stateNew = stateNew.set('selected', selected);
  }

  return stateNew;
};

export const atomsReducer = (state = Map(), action) => {
  switch (action.type) {
    case 'SELECTED_ATOMS':
      return setSelectedAtoms(state, action.atoms);
    case 'WS_RECEIVED_DEAL_DELETED':
      return removeDeletedDeals(state, action.id);
    default:
      return state;
  }
};

export const saveProductToLinkIdx = (dispatch, idx) => {
  dispatch({ type: 'FORM_CHANGED' });
  dispatch({ type: 'START_LINKING_TO_IDX', idx });
};

export const saveProductToLinkTransportIdx = (dispatch, idx) => {
  dispatch({ type: 'FORM_CHANGED' });
  dispatch({ type: 'START_LINKING_TRANPOSRT_TO_IDX', idx });
};
export const saveLinkIdxToAssignTransport = (dispatch, prodIdx, linkIdx,
  productId, fromList = false, multiNodalQuantity) => {
  dispatch({ type: 'FORM_CHANGED' });
  dispatch({ type: 'START_ASSIGNING_TRANSPORT_TO_LINK',
    prodIdx, linkIdx, productId, fromList, multiNodalQuantity });
};
export const linkExisting = (dispatch, prodIdx, linkIdx) => {
  dispatch({ type: 'FORM_CHANGED' });
  dispatch({ type: 'START_LINKING_EXISTING', prodIdx, linkIdx });
};
export const setLinkSavingAllowed = (dispatch, bool) => {
  dispatch({ type: 'CHANGED_LINK_SAVING_PERMISSION', bool });
};
export const setQuantity = (dispatch, quatityId, quantityObject) => {
  dispatch({ type: 'LINK_QUANTITY_CHANGED', quatityId, quantityObject });
};
export const setBlQuantity = (dispatch, id, blQuantity) => {
  dispatch({ type: 'LINK_BL_QUANTITY_CHANGED', id, blQuantity });
};
export const setBLDate = (dispatch, id, blDate) => {
  dispatch({ type: 'LINK_BL_DATE_CHANGED', id, blDate });
};
export const setNoTransportBl = (dispatch, id, value) => {
  dispatch({ type: 'LINK_No_TRANSPORT_BL_CHANGED', id, value });
};
export const clearQuantity = (dispatch) => {
  dispatch({ type: 'LINK_QUANTITY_CLEARED' });
};
export const setLinkFirst = (dispatch, id) => {
  dispatch({ type: 'SET_LINK_FIRST', id });
};
export const setLinkLast = (dispatch, id) => {
  dispatch({ type: 'SET_LINK_LAST', id });
};
export const stopLinking = (dispatch) => {
  dispatch({ type: 'STOP_LINKING' });
};
export const saveSelectedAtoms = (dispatch, atoms) => {
  dispatch({ type: 'SELECTED_ATOMS', atoms });
};
export const saveSelectedLinks = (dispatch, links) => {
  dispatch({ type: 'SELECTED_LINKS', links });
};
export const linkCreated = (dispatch, dealFrom, productIdx, links, allLinks) => {
  dispatch({ type: 'LINK_CREATED', dealFrom, productIdx, links, allLinks });
};

export const linkCanceled = (dispatch, productIdx) => {
  dispatch({ type: 'LINK_CANCELED', productIdx });
};
